var PersonList;

(function (PersonList) {
  PersonList["AUTHORS"] = "authors";
  PersonList["EXPERTS"] = "experts";
})(PersonList || (PersonList = {}));

export { PersonList as PersonListDoctissimoFr };